import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="flex flex-col items-center justify-center h-full py-24 text-center px-6">
        <div className="w-16 h-16 bg-red-50 dark:bg-red-900/20 rounded-2xl flex items-center justify-center mb-4">
          <svg className="w-8 h-8 text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
              d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
          </svg>
        </div>
        <h2 className="text-base font-semibold text-slate-700 dark:text-slate-300 mb-1">Something went wrong</h2>
        <p className="text-sm text-slate-400 dark:text-slate-500 mb-1">An unexpected error occurred.</p>
        {/* The message alone is often enough for a user to say something useful when
            they report this, and without it every crash looks identical. */}
        {this.state.error?.message && (
          <p className="text-xs text-slate-400 dark:text-slate-600 mb-5 max-w-md break-words">{this.state.error.message}</p>
        )}
        <a href="/" className="btn-primary text-sm px-4 py-2">Go home</a>
      </div>
    );
  }
}
